<script lang="ts">
  import {createEventDispatcher, onDestroy} from 'svelte';
  import {attachPopup} from '../../PopupBox/PopupBox.svelte';
  import MusicList from './MusicList.svelte';
  import {preview} from '../../../../store';
  let dom: HTMLElement;
  function openMusicSelection() {
    attachPopup(dom, MusicList);
  }

  const dispatch = createEventDispatcher();
  const unsubscribe = preview.subscribe(store => {
    if (store.music) dispatch('open');
    else dispatch('close');
  });

  onDestroy(unsubscribe);
</script>

<button
  bind:this={dom}
  class="flex w-full items-center rounded-xl border border-zinc-300 px-4 py-3"
  id="music_select"
  on:click={openMusicSelection}
  on:keypress={openMusicSelection}
>
  <span class="text-xs font-bold">Select Music</span>
  <div class="ml-auto block">
    <i class="fa fa-angle-right"></i>
  </div>
</button>
